import { render, staticRenderFns } from "./ElementLoader.vue?vue&type=template&id=505907ff"
import script from "./ElementLoader.vue?vue&type=script&lang=ts"
export * from "./ElementLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports